export default {};

export const messages = {
  THEM_THANH_CONG: 'Thêm mới thành công',
  LUU_THANH_CONG: 'Lưu thành công',
  LUU_THAT_BAI: 'Lưu không thành công',
  XOA_THANH_CONG: 'Xoá thành công',
  XOA_THAT_BAI: 'Xoá không thành công',
  GUI_THANH_CONG: 'Gửi thành công',
  TRUNG_DU_LIEU: 'Dữ liệu đã tồn tại',
  THONG_BAO: 'Thông báo',
  KHONG_CO_DU_LIEU: 'KHÔNG CÓ DỮ LIỆU!',
  DU_LIEU_CHUA_THAY_DOI: 'Dữ liệu chưa thay đổi',
  LOI_HE_THONG: 'CÓ LỖI XẢY RA TRONG QUÁ TRÌNH TẢI DỮ LIỆU!',
  UPLOAD_JPG: 'Bạn upload không đúng định dạng file!',
  UPLOAD_DUNG_LUONG: 'Bạn upload quá dung lượng file!',
  UPLOAD_KHONG_THANH_CONG: 'Upload không thành công',
  FIELD_EMPTY: 'Bạn không được bỏ trống trường này!',
  MAX_2_FILE: 'Bạn chỉ được tải tối đa 2 file',
  DUNG_LUONG_25MB: 'Dung lượng tối đa 25MB',
  DINH_DANG_FILE: 'Hãy chọn file có định dạng Pdf, Doc, Docx, Xlsx, Xls, Xlsb, Xlt, Jpeg, Png.',
  DANG_NHAP_THANH_CONG: 'Đăng nhập thành công',
  CAP_NHAT_THANH_CONG: 'Cập nhật thành công',
  CAP_NHAT_KHONG_THANH_CONG: 'Cập nhật không thành công',
  CHUYEN_XU_LY_THAT_BAI: 'Vui lòng chọn người nhận văn bản nếu muốn chuyển xử lý',
  GUI_KHONG_THANH_CONG: 'Gửi không thành công',
  DUYET_THANH_CONG: 'Thành công',
  DUYET_KHONG_THANH_CONG: 'Không thành công',
  // Define error message
  ERROR_XU_LY_CHINH: '"Người nhận văn bản" và "Người xử lý" không trùng nhau',
  ERROR_EMAIL: 'Email không đúng định dạng\n',
  ERROR_REQUIRED: 'Bạn không được để trống trường này!\n',
  ERROR_MAX: 'Anh/chị đã nhập quá {value} kí tự cho phép!\n',
  ERROR_UPLOAD_MAX_FILE: 'Bạn chỉ được tải tối đa {value} file\n',
  ERROR_UPLOAD_MAX_SIZE: 'Dung lượng file tối đa không được vượt quá {value}MB!\n',
  ERROR_UPLOAD_TYPE: 'Bạn upload không đúng định dạng file!\n',
  ERROR_UPLOAD_FILE_TYPE: 'Chỉ hỗ trợ tải lên các định dạng file {value}!\n',
  ERROR_UPLOAD_AVATAR: 'Hệ thống hỗ trợ định dạng file {TYPE} dung lượng < {SIZE}!\n',
  ERROR_PHONENUMBER: 'Số điện thoại là chữ số và có 10 - 11 ký tự\n',
  ERROR_NUMBER: 'Anh/chị đã nhập không đúng định dạng số\n',
  ERROR_EMPTY_GOP_Y: 'Vui lòng nhập nội dung góp ý',
  NOI_DUNG_TRUNG_LAP: 'Nội dung đưa lên trùng lặp. Vui lòng thay đổi lại trước khi gửi lên.',
  // message số đến
  SO_DEN: {
    TU_SO: 'Số đến: Từ số phải nhỏ hơn Số đến: Đến số!',
    DEN_SO: 'Số đến: Đến số phải lớn hơn Số đến: Từ số!'
  },
  // hồ sơ công việc
  LUU_HO_SO_CONG_VIEC: 'Tạo hồ sơ công việc thành công!',
  // Common
  MODAL_DELETE_TITLE: 'Bạn có muốn xoá',
  MODAL_DELETE_CONTENT: 'Bạn sẽ xoá bản ghi này. Nhấn Đồng ý để xác nhận.',
  MODAL_CONFIRM_OK: 'Đồng ý',
  MODAL_CONFIRM_CANCEL: 'Huỷ',
  HET_PHIEN_LAM_VIEC: 'Hết phiên làm việc, Vui lòng đăng nhập lại !',
  DU_LIEU_KO_TON_TAI: 'Dữ liệu không tồn tại',
  DU_LIEU_DANG_DUOC_SU_DUNG: 'Không xóa được, Do dữ liệu đang được sữ dung ở 1 tính năng khác !',
  DICH_VU_KO_TON_TAI: 'Dịch vụ không tồn tại',
  KHONG_PHAN_HOI: 'Không nhận được phản hồi từ máy chủ',
  DU_LIEU_DANG_SU_DUNG: 'DỮ LIỆU ĐANG ĐƯỢC SỬ DỤNG!',
};
